/**
 * @class ProductPageStickyCta
 * Class that controls the sticky cta box in the Skye Product Pages and Cert Suite Pages. 
 */
class ProductPageStickyCta {
    /**
     * 
     * @param {HMTL Object} targetCta - The query selected Product CTA Box object.
     * @param {HTML object} stopShowElement - The HTML element that used to determine the stop point where the sticky product CTA will stop being active.
     * @param {string} stickyClass - The HTML class that is used to indicate the active state of the sticky product CTA. 
     * @param {string} nonStickyClass - The HTML class that is used to indicate the inactive state of the sticky product CTA. 
     * @param {HTML Object} ctaParent - The query-selected parent element that helps control the placement of the sticky product CTA during state changes.
     * @param {string} navigationClass -The class of the top <header> element in the page.
     * @param {HTML Object} currentBanner - The query-selected banner block in the page.
     * @param {HTML Object} certsCollapse - The query-selected certs dropdown in the product and cert suite page banner areas.
     * 
     */
    constructor(targetCta, stopShowElement, stickyClass, nonStickyClass, ctaParent, navigationClass, currentBanner, certsCollapse) {
        this.productBox = targetCta;
        this.stopShowElement = stopShowElement;
        this.stickyClass = stickyClass;
        this.nonStickyClass = nonStickyClass;
        this.stopShowEle = stopShowElement;
        this.qbx = this.LoadCheck('#productBox');
        this.winWidth = this.GetWindowWidth();
        this.getScroll = this.GetWindowScroll();
        this.ctaParent = ctaParent;
        this.banner = currentBanner;
        this.bannerHeightCollapsed = 0;
        this.certsCollapse = certsCollapse;
        this.navigationElement = navigationClass;
    }
    /**
     * @method LoadCheck - Method checks to see if an object has loaded, kind of like the componentDidMount() lifecycle method in React.
     * 
     * @param {HTMLObject} theObject - the HTML class or id for the element that is to be evaluated.
     * 
     * @return boolean - check: provides a boolean as a result which will indicate if the object has loaded or not loaded (true = loaded, false = not loaded).
     */
    LoadCheck(theObject) {
        var check = false;
        if (document.querySelector(theObject) !== undefined && document.querySelector(theObject) !== null && document.querySelector(theObject) !== '') {
            check = true;
        } else {
            check = false;
        }
        return check;
    }
    /**
     * @method GetWindowWidth - A method that returns the value of the browser window width.
     * 
     * @return integer - winW: the calculated browser window width total.
     * 
     */
    GetWindowWidth() {
        var winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return winW;
    };
    /**
     * @method GetWindowScroll - A method that returns the scroll top value for the browser document window.
     * 
     * @return integer - winScrollTop: returns the integer value of the current scrollTop for an active browser window.
     */
    GetWindowScroll() {
        var winScrollTop;
        winScrollTop = document.documentElement.scrollTop || window.pageYOffset;
        return winScrollTop;
    }
    /**
     * @method GetBannerHeightCollapsed - Retrieves the collapsed offsetHeight (natural height or initial height) of the banner in a product or cert suite page.
     * 
     * @return integer - bCollapsed: returns the integer value for the initial offsetHeight of the banner.
     * 
     */
    GetBannerHeightCollapsed() {
        if (this.qbx) {
            var bCollapsed = this.banner.offsetHeight;
            this.bannerHeightCollapsed = bCollapsed;
            return bCollapsed;
        }
    }
    /**
     * @method GetBannerHeightExpanded - Retrieves the offsetHeight (or actual height) of the expanded (influenced) banner in a product or cert suite page.
     * 
     * @return integer - cExpanded: returns the integer value for the offsetHeight of the expanded banner.
     * 
     */
    GetBannerHeightExpanded() {
        if (this.qbx) {
            var cExpanded = 0;
            if (this.certsCollapse.getAttribute('aria-expanded') === 'true') {
                cExpanded = this.banner.offsetHeight;
            }
            return cExpanded;
        }
    }
    /**
     * @method SetNormalState - Sets the state of the product CTA to inactive or normal.
     * @param {string} pbox1 - HTML Object representation of the sticky product CTA element with inactive class.
     * 
     * @return HTMl Object: returns the sticky CTA with modified class.
     */
    SetNormalState(pbox1) {
        pbox1.setAttribute('class', this.nonStickyClass);
        return pbox1;
    };
    /**
     * @method SetStickyState - Sets the state of the product CTA to active or sticky.
     * @param {string} pbox1 - HTML Object representation of the sticky product CTA element with active class.
     * 
     * @return HTMl Object: returns the sticky CTA with modified class.
     */
    SetStickyState(pbox1) {
        pbox1.setAttribute('class', this.stickyClass);
        return pbox1;
    };
    /**
     * @method SetStickyness - This method decides which state to set based on the qualifying screen width value, and scrollTop 
     * value while calculating the vertical placement of the HTML object that is set as the limiter, at the bottom of the page.
     * For example, the footer could be the stop point which makes the sticky CTA box return to the top of the page, aka disappear 
     * if a user has scrolled down the page, and has passed the limiting value.
     */
    SetStickyness() {
        /* Store height of header on load or when aria-expanded is false;
        store height of hedaer on load when aria-expanded is true and the find difference
        for comparson within if condition against the scroll val*/
        if (this.qbx) {
            var status = false;
            var winWd = this.GetWindowWidth();
            var theScrollVal = this.GetWindowScroll();

            if (winWd > 1599) {
                this.SetStickyState(this.productBox);
                status = true;
                // If the banner is collapsed... 
                if (this.certsCollapse.getAttribute('aria-expanded') === 'false') {
                    var bannerHeightCollapsed = this.banner.offsetHeight;
                    var navigationHeight = this.navigationElement.offsetHeight;
                    var scrollActivatePoint = ((bannerHeightCollapsed + navigationHeight) - /*195*/ 415);
                    /*console.log(this.stopShowElement.offsetTop + ' ' +  this.stopShowElement.offsetHeight);  check the output values by uncommenting this line */
                    if (theScrollVal > scrollActivatePoint && theScrollVal < (this.stopShowElement.offsetTop - (this.stopShowElement.offsetHeight + 60))) {
                        this.SetStickyState(this.productBox);
                        status = true;
                    } else {
                        this.SetNormalState(this.productBox);
                        status = false;
                    }
                } else {
                    /* If the banner is expanded opposite of aria-expanded === false, get the difference between and expanded banner and a collapsed one.
                    Use the header height, (collapsed and expanded) and footer offset to determine the sticky placement and normal state placement .*/
                    var bannerHeightExpanded = this.GetBannerHeightExpanded();
                    var _navigationHeight = this.navigationElement.offsetHeight;
                    var _scrollActivatePoint = ((bannerHeightExpanded + _navigationHeight) - /*195*/ 415);
                    if (theScrollVal > _scrollActivatePoint && theScrollVal < (this.stopShowElement.offsetTop - (this.stopShowElement.offsetHeight + 60))) {
                        this.SetStickyState(this.productBox);
                        status = true;
                    } else {
                        this.SetNormalState(this.productBox);
                        status = false;
                    }
                }
            } else {
                this.SetNormalState(this.productBox);
                status = false;
            }
        }
        return status;
    };
}

export default ProductPageStickyCta;